import { createFileRoute, redirect } from '@tanstack/react-router'

// The arrangements list is the Houses page now (a house's own Roster of Care
// tab, and "Arrangements without a house" for the rest).
export const Route = createFileRoute(
  '/_authenticated/_organization/scheduler/sil/'
)({
  beforeLoad: () => {
    throw redirect({ to: '/houses', replace: true })
  },
})
